import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

@ngCore.Component({
  imports: [ds.value.Component],
  selector: 'atn-readonly-value',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** DMS schema feature needed to extract dms schema */
  private readonly _dmsSchemaFeature = ngCore.inject(state.dms.schema.Feature)

  /** @see {@link ents.core.dms.data.Value.Type} */
  public readonly typeSg = ngCore.input<ents.core.dms.data.Value.Type>(
    undefined,
    {
      alias: 'type',
    },
  )

  /**
   * DMS type converted to
   * {@link ents.core.common.value.types.Type common type}, needed to convert
   * value into rawValue in order to pass it to {@link ds.value.Component ds-value} component
   */
  private readonly _commonTypeSg = ngCore.computed((type = this.typeSg()) =>
    type
      ? ents.core.dms.data.Value.Type.toCommonValueType(
          type,
          this._dmsSchemaFeature.selectors.schema.asSignal(),
        )
      : undefined,
  )

  /** TODO:  */
  public readonly labelSg = ngCore.input<string>(undefined, {
    alias: 'label',
  })

  /** @see {@link ents.core.dms.data.Value} */
  public readonly valueSg = ngCore.input.required<ents.core.dms.data.Value>({
    alias: 'value',
  })

  /** Value converted to {@link ents.core.common.value.Raw raw} format in order to use it with {@link ds.value.Component ds-value} component */
  public readonly rawValueSg = ngCore.computed(
    (value = this.valueSg(), type = this._commonTypeSg()) =>
      type ? ents.core.common.value.Raw.cast(value, type) : undefined,
  )

  /** TODO: maybe this should be removed? */
  public readonly valueInfoSg = ngCore.computed<
    ents.core.common.value.Info | undefined
  >((type = this._commonTypeSg()) => {
    if (!type) {
      return undefined
    }

    return { type }
  })
}
